import React from 'react';
import { Box, Container, Typography, Card, CardContent, Avatar, Grid, Button, Rating } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { brand, pageHeroRichSxFor, pageElevatedCardSx, pageHeroImages, pageHeroType } from '../brandTheme';

const testimonials = [
  {
    name: 'Naresh Chavan',
    role: 'Salaried Person',
    content: 'When I visited Om Sai Enterprises it just took a few minutes to process the loan and the process was very transparent. Highly Recommended Agency',
    rating: 5,
  },
  {
    name: 'Akshay Sakpal',
    role: 'Salaried Person',
    content: 'Best place for all types of loan... Friendly atmosphere, knowledgeable people and good advisor.... Clear your debts and make your dreams come true',
    rating: 5,
  },
  {
    name: 'Akshay Pathare',
    role: 'Business Person',
    content: 'I loved the way Om Sai Enterprises took my documents digitally while applying for personal loan and gave faster disbursal into my bank account. Thanks Team IIFL for giving me a truly seamless & digital experience.',
    rating: 5,
  },
  {
    name: 'Priya Sharma',
    role: 'Home Maker',
    content: 'Getting a gold loan was so easy with Om Sai. They offered the best value for my gold and the interest rates are very reasonable. Safe and secure process.',
    rating: 5,
  },
  {
    name: 'Vikram Singh',
    role: 'Small Business Owner',
    content: 'My business loan application was rejected by two banks, but Om Sai Enterprises understood my business model and helped me secure the funding I needed for expansion.',
    rating: 4,
  },
  {
    name: 'Anjali Desai',
    role: 'IT Professional',
    content: 'The team is very professional. They helped me compare different home loan options and choose the one with the lowest EMI. Very happy with their service.',
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <Box className="component-box component-box--flush">
      <Box id="testimonials" sx={{ bgcolor: brand.surfaceWarm }}>
        <Box sx={{ ...pageHeroRichSxFor(pageHeroImages.testimonials), textAlign: 'center' }}>
          <Container maxWidth="md">
            <Typography component="p" sx={{ ...pageHeroType.eyebrow, mb: 2.5, textAlign: 'center' }}>
              CLIENT STORIES
            </Typography>
            <Typography component="h1" sx={{ ...pageHeroType.title, mb: 2.5, textAlign: 'center' }}>
              What Our <Box component="span" sx={{ color: '#fde68a' }}>Clients Say</Box>
            </Typography>
            <Typography sx={{ ...pageHeroType.subtitle, mb: 4, maxWidth: 680, mx: 'auto', textAlign: 'center' }}>
              Discover how we&apos;ve helped thousands of individuals and businesses achieve their financial goals.
            </Typography>
            <Button
              variant="contained"
              size="large"
              href="#/contact"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: '999px',
                fontWeight: 800,
                bgcolor: '#fbbf24',
                color: '#422006',
                boxShadow: '0 8px 28px rgba(0,0,0,0.25)',
                '&:hover': { bgcolor: '#fcd34d' },
              }}
            >
              Share Your Story
            </Button>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ py: { xs: 8, md: 10 } }}>
          <Typography component="h2" align="center" sx={{ mb: 2, fontWeight: 800, letterSpacing: '-0.02em', color: brand.slate, fontSize: { xs: '1.9rem', md: '2.35rem' } }}>
            Trusted by <Box component="span" sx={{ color: brand.primary }}>Hundreds</Box>
          </Typography>
          <Typography align="center" color="text.secondary" sx={{ mb: 8, maxWidth: 560, mx: 'auto', fontWeight: 500, fontSize: { xs: '1.0625rem', md: '1.125rem' }, lineHeight: 1.65 }}>
            We take pride in the trust our customers place in us.
          </Typography>

          <Grid container spacing={3}>
            {testimonials.map((testimonial, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    height: '100%',
                    ...pageElevatedCardSx,
                    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      boxShadow: '0 28px 56px rgba(15, 23, 42, 0.12)',
                      borderColor: brand.primary,
                    },
                  }}
                >
                  <CardContent sx={{ p: 3.5 }}>
                    <FormatQuoteIcon sx={{ fontSize: 36, color: 'rgba(15, 118, 110, 0.25)', mb: 1 }} />
                    <Rating value={testimonial.rating} readOnly size="small" sx={{ mb: 2, '& .MuiRating-iconFilled': { color: brand.accent } }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: brand.primary,
                          mr: 2,
                          width: 52,
                          height: 52,
                          fontSize: '1.25rem',
                          fontWeight: 800,
                        }}
                      >
                        {testimonial.name[0]}
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={800}>
                          {testimonial.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {testimonial.role}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="body1" sx={{ fontStyle: 'italic', color: brand.muted, lineHeight: 1.7 }}>
                      &ldquo;{testimonial.content}&rdquo;
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Testimonials;
